module.exports = __webpack_public_path__ + "img/g1_conglinmimi.62228344.jpg";